var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestimonialNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9C0 8.73482 0.101588 8.4805 0.282415 8.29299C0.463242 8.10548 0.708496 8.00014 0.964224 8.00014H23.7064L17.6376 1.70902C17.4565 1.52128 17.3548 1.26664 17.3548 1.00112C17.3548 0.735608 17.4565 0.480969 17.6376 0.293222C17.8186 0.105475 18.0642 6.25573e-09 18.3203 0C18.5763 -6.25573e-09 18.8219 0.105475 19.0029 0.293222L26.7167 8.2921C26.8065 8.38498 26.8778 8.49531 26.9264 8.61679C26.975 8.73826 27 8.86848 27 9C27 9.13152 26.975 9.26174 26.9264 9.38321C26.8778 9.50469 26.8065 9.61502 26.7167 9.7079L19.0029 17.7068C18.8219 17.8945 18.5763 18 18.3203 18C18.0642 18 17.8186 17.8945 17.6376 17.7068C17.4565 17.519 17.3548 17.2644 17.3548 16.9989C17.3548 16.7334 17.4565 16.4787 17.6376 16.291L23.7064 9.99986H0.964224C0.708496 9.99986 0.463242 9.89452 0.282415 9.70701C0.101588 9.5195 0 9.26518 0 9V9Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 27,
    y1: 7.47273,
    x2: 6.02977,
    y2: 36.4724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialNext);
export default __webpack_public_path__ + "static/media/testimonial--next.2b2e378e1c7367f538269c6e32031682.svg";
export { ForwardRef as ReactComponent };